<wl-content-section [id]="id()" [theme]="theme()">
  <wl-content-top-tasks-section [heading]="rendering().fields?.heading">
    <wl-content-top-tasks-button
      [icon]="rendering().fields?.firstTopTaskIcon"
      [link]="rendering().fields?.firstTopTaskLink"
      class="col-12 col-lg-4"
    />
    <wl-content-top-tasks-button
      [icon]="rendering().fields?.secondTopTaskIcon"
      [link]="rendering().fields?.secondTopTaskLink"
      class="col-12 col-lg-4"
    />
    <wl-content-top-tasks-button
      [icon]="rendering().fields?.thirdTopTaskIcon"
      [link]="rendering().fields?.thirdTopTaskLink"
      class="col-12 col-lg-4"
    />
  </wl-content-top-tasks-section>
</wl-content-section>
